//import logo from "./logo.svg";
import { useState } from "react";
import "./App.css";
import Editor from "./components/Editor";
import Example from "./components/Example";
import { Route, Routes } from "react-router-dom";

function App() {
    const [code, setCode] = useState("");
    const [showExample, setShowExample] = useState(false);
    function handleChange(item) {
        setShowExample(!showExample);
    }

    return (
        <div className="App">
            <Routes>
                <Route
                    path="/"
                    element={<Editor onChange={handleChange} lang={"html"} />}
                />
                <Route path="/example" element={<Example />} />
            </Routes>
        </div>
    );
}

export default App;
